import { undefinedOrTransformToDTOCurried } from '@maia/utils';
import { BrokerDto, INoteEntity } from '../shared';
import { match } from 'ts-pattern';
import { DocumentDto } from './common/document.dto';
import { IAttachmentEntity } from '../entitites/attachments.entity';

export class CreateNoteDto {
  readonly title: string;
  readonly description: string;
  readonly category: string;
  readonly attachments: Array<IAttachmentEntity>;

  constructor(params: {
    title: string;
    description: string;
    category: string;
    attachments: Array<IAttachmentEntity>;
  }) {
    this.title = params.title;
    this.description = params.description;
    this.category = params.category;
    this.attachments = params.attachments;
  }
}

export class NoteDto {
  readonly guid: string;
  readonly title: string;
  readonly icon: string;
  readonly type: INoteEntity['type'];
  readonly createdAt: Date;
  readonly createdBy: BrokerDto;
  readonly content: string;
  readonly attachments: Array<DocumentDto>;

  constructor(note: INoteEntity) {
    this.guid = note.guid;
    this.title = note.title;
    this.type = note.type;
    this.icon = mapTypeToIcon(note.type);
    this.createdAt = new Date(note.created_at);
    this.createdBy = new BrokerDto(note.created_by);
    this.content = note.content;
    this.attachments = note.attachments.map(
      (attachment) => new DocumentDto(attachment),
    );
  }
}

export const undefinedOrNote = undefinedOrTransformToDTOCurried(
  (entity: INoteEntity) => new NoteDto(entity),
);

export const mapTypeToIcon = (type: INoteEntity['type']) => {
  return match(type)
    .returnType<string>()
    .with('phone_correspondence', () => 'phone')
    .with('mail_correspondence', () => 'envelope')
    .with('comment', () => 'comment-alt-lines')
    .with('question', () => 'question-circle')
    .otherwise(() => 'question');
};
